export default __webpack_public_path__ + "static/media/franchising-img.09ae9a1e.png";